import React from 'react';

const PrivacyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-600">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-slate-800 rounded-3xl shadow-xl border border-slate-700 p-8">
          <h1 className="text-3xl font-bold text-white mb-6 text-center">
            Согласие на обработку персональных данных
          </h1>
          
          <div className="text-slate-300 text-sm mb-8 text-center">
            Дата размещения: 14 августа 2025
          </div>
          
          <div className="space-y-6 text-slate-300 leading-relaxed">
            <p>
              Я, субъект персональных данных, свободно, своей волей и в своём интересе, даю согласие 
              <span className="text-[#7538d5] font-semibold"> ООО "ИКС ДРАЙВ" </span>
              (ИНН: 7842222864, КПП: 784201001, ОГРН: 1247800055436, далее — "Оператор") на обработку моих персональных данных, в том числе с использованием средств автоматизации.
            </p>
            
            <div className="space-y-4">
              <div>
                <h2 className="text-[#7538d5] font-semibold text-lg mb-2">1. Состав персональных данных:</h2>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Фамилия, имя, отчество;</li>
                  <li>Мобильный телефон;</li>
                  <li>Паспортные данные;</li>
                  <li>ИНН.</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-lg mb-2">2. Источники получения данных:</h2>
                <p>
                  Данные могут быть получены напрямую от меня, а также от сторонних сервисов авторизации и идентификации, 
                  включая МТС ID, T-ID и иные, с которыми у Оператора заключены действующие соглашения.
                </p>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-lg mb-2">3. Цели обработки:</h2>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Идентификация при регистрации;</li>
                  <li>Использование сервиса "Сделка и Точка";</li>
                  <li>Выполнение обязательств по законодательству РФ;</li>
                  <li>Проведение финансовых операций через платёжного партнёра.</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-lg mb-2">4. Срок обработки:</h2>
                <p>
                  Согласие действует до момента отзыва. Отзыв возможен путём направления соответствующего уведомления 
                  на адрес электронной почты 
                  <span className="text-[#7538d5] font-semibold"> support@dealtochka.com</span>.
                </p>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-lg mb-2">5. Условия передачи данных:</h2>
                <p className="mb-2">Данные могут быть переданы:</p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>В правоохранительные органы и суды РФ — по их законному запросу;</li>
                  <li>Платёжному партнёру — ООО "Банк Точка" в рамках работы "Сделка и Точка" ООО "ИКС ДРАЙВ".</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-lg mb-2">6. Прочие положения:</h2>
                <p>
                  Я подтверждаю, что ознакомлен(а) с Политикой конфиденциальности и условиями использования платформы 
                  <span className="text-[#7538d5] font-semibold"> "Сделка и Точка"</span>, а также согласен(а) на возможное 
                  взаимодействие с уполномоченными третьими лицами в рамках указанных целей.
                </p>
              </div>
            </div>
          </div>
          
          <div className="mt-8 pt-6 border-t border-slate-700 text-center">
            <div className="text-slate-400 text-sm">
              ООО "ИКС ДРАЙВ" • ИНН: 7842222864 • КПП: 784201001 • ОГРН: 1247800055436
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
